//title  标题
//mobile ['18211111111']
import React, {Component} from 'react';
import {Input} from "antd";
import keyword_del from "../../cloud/image/common/zkAddKeyword/keyword_del.png";
import ZkFormItem from "../form/zkFormItem";

class AddMobileNumber extends Component {
    constructor(props) {
        super(props);
        this.state={
            mobile:['']
        }
    }
    componentDidMount() {
        if(this.props.mobile){
            if(this.props.mobile.length > 0){
                let flag = this.props.mobile.every(item=>item!='')
                if(flag){
                    if(this.props.mobile.length < 5){
                        this.props.mobile.push('')
                    }
                }
                this.setState({
                    mobile:this.props.mobile
                })
            }
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log(nextProps,'asdfdsfds')
        // if (nextProps.mobile && JSON.stringify(nextProps.mobile) !== JSON.stringify(this.props.mobile)) {
        //
        // }
    }

    mobileItemChange(index,e) {
        let value= e.target.value
        let newMobile = [...this.state.mobile]
        newMobile[index] = value
        this.setState({
            mobile:newMobile
        },()=>{
            let newArr = this.state.mobile
            if(newArr.length < 5){
                let flag = newArr.every(item=> item!='')
                if(flag){
                    newArr.push('')
                }
            }
            this.setState({
                mobile:newArr
            })
         })
    }

    //点击删除
    deleteMobile(index) {
        let newMobile = [...this.state.mobile]
        if(newMobile.length == 1){
            newMobile[index]=''
        }else {
            newMobile.splice(index,1)
        }
        this.setState({
            mobile:newMobile
        })
    }
    //抛出数据
    getData=()=>{
        let newData = this.state.mobile.filter(item=>item!='')

        return newData
    }

    render() {
        const {title} = this.props
        const {mobile} = this.state
        return (
            <ZkFormItem title={title} colon={true} titleWidth={'56px'} conWidth={'396px'}>
                <ul className={'new_add_customer_data_phone_number'}>
                    {
                        mobile.map((item,index)=>{
                            return <li key={index}>
                                <Input type={'number'} placeholder={'请输入手机号码'} value={item} onChange={this.mobileItemChange.bind(this,index)} maxLength={11}/>
                                {
                                    item !='' ? <img src={keyword_del} className={'keyword_del'} onClick={this.deleteMobile.bind(this,index)}/> : ''
                                }
                            </li>
                        })
                    }
                </ul>
            </ZkFormItem>
        );
    }
}

export default AddMobileNumber;